// extracted by mini-css-extract-plugin
export default {"MyQuizzesListScreen__Title":"MyQuizzesListScreen_MyQuizzesListScreen__Title__gvV8B","MyQuizzesListScreen__Desc":"MyQuizzesListScreen_MyQuizzesListScreen__Desc__NXkH6"};